import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { meQueryOptions } from '~/lib/auth';

export const Route = createFileRoute('/_authenticated/admin')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(meQueryOptions);
    if (session.role !== 'admin') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/jobs' });
    }
  },
  component: AdminLayout
});

function AdminLayout(): React.ReactNode {
  return <Outlet />;
}
